import { useState, useEffect } from 'react';
import { api } from '../services/api';

interface TokenUsage {
  total_tokens: {
    value: number;
  };
  total_input_tokens: {
    value: number;
  };
  total_output_tokens: {
    value: number;
  };
  total_cost: {
    value: number;
  };
  usage_by_model: {
    buckets: Array<{
      key: string;
      total_tokens: { value: number };
      total_cost: { value: number };
    }>;
  };
}

export const useTokenUsage = (email: string | undefined) => {
  const [tokenUsage, setTokenUsage] = useState<TokenUsage | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchTokenUsage = async () => {
      if (!email) {
        setIsLoading(false);
        return;
      }

      try {
        const response = await api.get(`/users/${email}/token-usage`);
        setTokenUsage(response.data.data);
      } catch (err) {
        console.error('Error fetching token usage:', err);
        setError('Failed to fetch token usage');
      } finally {
        setIsLoading(false);
      }
    };

    fetchTokenUsage();
  }, [email]);

  const formatTokenCount = (count: number) => {
    if (count >= 1000000) {
      return `${(count / 1000000).toFixed(1)}M`;
    } else if (count >= 1000) {
      return `${(count / 1000).toFixed(1)}K`;
    }
    return count.toString();
  };

  return {
    tokenUsage,
    isLoading,
    error,
    formatTokenCount
  };
};